export const GET_THRESHOLD_DATA = "GET_THRESHOLD_DATA";
export const SET_LOADING_THRESHOLD_DATA = "SET_LOADING_THRESHOLD_DATA";
export const FETCH_THRESHOLD_DETAILS = "FETCH_THRESHOLD_DETAILS";
export const SET_THRESHOLD_DETAILS_LOADING = "SET_THRESHOLD_DETAILS_LOADING";
export const SET_SIMS_TO_ADD_OR_DELETE_VALUE = "SET_SIMS_TO_ADD_OR_DELETE_VALUE";
export const SET_SIMS_ADD_OR_DELETE_CONFIRM_LOADING = "SET_SIMS_ADD_OR_DELETE_CONFIRM_LOADING";
export const FETCH_SIMS_NEW_SOGLIA = "FETCH_SIMS_NEW_SOGLIA";
export const SET_LOADING_SIMS_NEW_SOGLIA = "SET_LOADING_SIMS_NEW_SOGLIA";
export const UPDATE_RULE = "UPDATE_RULE";
export const UPDATE_RULE_LOADING = "UPDATE_RULE_LOADING";
export const DELETE_RULES_LOADING = "DELETE_RULES_LOADING";
export const THRESHOLDS_LOADING = "THRESHOLDS_LOADING";
export const GET_CREATE_REGOLA_MENU_ITEMS = 'GET_CREATE_REGOLA_MENU_ITEMS';

